import React from "react";
import { useNavigate } from "react-router-dom";
import "./Top_Heading.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb_Comp from "../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import { formatNewDate } from "../../../utils/common";

const Top_Heading = ({ order }) => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: "HOME", link: "/home", active: false },
    { label: "SHOP", link: "", active: false },
    { label: "ORDER DETAILS", link: "", active: true },
  ];
  return (
    <>
      <div className="breadcrumo_div">
        <div className="container">
          <Breadcrumb_Comp data={breadcrumbs} />
        </div>
      </div>

      <div className="processing_div">
        <p className="inner_text">Processing your order</p>
      </div>

      <section className="Top_Heading">
        <div className="container">
          <div className="content_holder">
            <div className="top_div">
              <p className="order_id">Order ID #{order?.invoice_no || ""}</p>
              <p className="date_text">{formatNewDate(order?.createdAt, 'datetime')}</p>
            </div>
            <div className="bottom_div">
              <p className="order_id">₹ {order?.total_amount || ""}</p>

              <div className="right_div">
                <div className="call_text">
                  <FontAwesomeIcon icon={faPhone} className="call_icon" />
                  <span className="inner_text">Call</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Top_Heading;
